import React from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router";
import { useTooltipRebuild } from "hooks/useTooltipRebuild";
import useImageFallback from "hooks/useImageFallback";

import "./QrDesignName.css";

export function QrDesignName({ dependentValues = {}, value }){
	const { libraryId } = useParams();
	let { previewImageUrl, id } = dependentValues;
	const { imageSrc } = useImageFallback(previewImageUrl, "/images/qr-code-placeholder@3x.png");

	useTooltipRebuild();

	return (
		<div className="qr-design-name-col">
			<div className="image-thumbnail">
				<img
					src={imageSrc}
					alt="Logo"
					className="qr-design-logo"
					data-tip={`<img src="${imageSrc}" alt="QR Design Preview"/>`}
					data-class="qr-design-img-tooltip"
					data-border-color="#fff"
					data-background-color="#fff"
					data-html
				/>
			</div>
			<span title={value} className="design-name name-overflow">
				<Link
					to={`/library/${libraryId}/qr-designs/${id}/codes/`}
				>
					{value}
				</Link>
			</span>
		</div>
	);
}
